// Query-key factory for the /api/v1/me profile resource. Single-document
// resource (no list / detail / filter variants) so the surface is small,
// but the factory shape stays consistent with other features and lets
// callers invalidate via `meKeys.detail()` without re-typing the literal.
export const meKeys = {
  all: ['me'] as const,
  detail: () => [...meKeys.all, 'detail'] as const,
};
